module.exports = __webpack_public_path__ + "img/swap_horizontal_circle_opsz24.4d7ad2e3.svg";